import {
  TubeGeometry,
  CircleGeometry,
  SphereGeometry,
  MeshNormalMaterial,
  MeshToonMaterial,
  MeshPhongMaterial,
  Mesh,
  Group,
  Curve,
  Vector3
} from 'three'

class JellyFish {
  constructor() {
    this.group = new Group()
    this.materials = []

    this.geometry = new SphereGeometry(1, 15, 10, 0, 2 * Math.PI, 0, 0.5 * Math.PI)
    this.headMaterial = new MeshPhongMaterial({ color: 0xd656d2, transparent: true, opacity: 0.3 })
    this.materials.push(this.headMaterial)
    this.head = new Mesh(this.geometry, this.headMaterial)
    this.head.rotation.y = -Math.PI / 2
    this.head.position.x = 0.5
    this.head.position.y = -0.5
    this.head.position.z = -3

    this.group.add(this.head)
    this.tentacles = new Group()
    this.group.add(this.tentacles)

    this.geometry = new SphereGeometry(0.9, 15, 10, 0, 2 * Math.PI, 0, 0.5 * Math.PI)
    this.innerHeadMaterial = new MeshNormalMaterial({ color: 0xffffff })
    this.materials.push(this.innerHeadMaterial)
    this.innerhead = new Mesh(this.geometry, this.innerHeadMaterial)
    this.innerhead.rotation.y = -Math.PI / 2
    this.innerhead.position.x = 0.5
    this.innerhead.position.y = -0.5
    this.innerhead.position.z = -3

    this.group.add(this.innerhead)

    this.geometry = new CircleGeometry(1, 15)
    this.bottomMaterial = new MeshNormalMaterial({ color: 0xffffff, transparent: true, opacity: 0.7 })
    this.materials.push(this.bottomMaterial)
    this.bottom = new Mesh(this.geometry, this.bottomMaterial)
    this.bottom.rotation.x = Math.PI / 2
    this.bottom.rotation.z = Math.PI / 2
    this.bottom.position.x = 0.5
    this.bottom.position.y = -0.5
    this.bottom.position.z = -3
    this.group.add(this.bottom)

    class FirstCurve extends Curve {
      constructor(scale = 1) {
        super()

        this.scale = scale
      }

      getPoint(t, optionalTarget = new Vector3()) {
        const tx = Math.sin(2 * Math.PI * t)
        const ty = t * 3 - 1.5
        const tz = 0

        return optionalTarget.set(tx, ty, tz).multiplyScalar(this.scale)
      }
    }
    class SecondCurve extends Curve {
      constructor(scale = 1) {
        super()

        this.scale = scale
      }

      getPoint(t, optionalTarget = new Vector3()) {
        const tx = Math.sin(-2 * Math.PI * 5)
        const ty = t * 3 - 1.5
        const tz = 0

        return optionalTarget.set(tx, ty, tz).multiplyScalar(this.scale)
      }
    }
    const path = new FirstCurve(5)
    this.geometry = new TubeGeometry(path, 20, 2, 3, false)
    this.leg1Material = new MeshToonMaterial({ color: 0xd656d2 })
    this.materials.push(this.leg1Material)
    this.leg1 = new Mesh(this.geometry, this.leg1Material)
    this.leg1.scale.set(0.1, 0.1, 0.1)
    this.leg1.position.x = -0.1
    this.leg1.position.y = -1.1
    this.leg1.position.z = -3
    this.leg1.rotation.y = Math.PI / 2

    this.tentacles.add(this.leg1)

    this.geometry = new TubeGeometry(path, 16, 2, 2, false)
    this.leg3Material = new MeshToonMaterial({ color: 0xdd98dc })
    this.materials.push(this.leg3Material)
    this.leg3 = new Mesh(this.geometry, this.leg3Material)
    this.leg3.scale.set(0.1, 0.1, 0.1)
    this.leg3.position.x = 0.5
    this.leg3.position.y = -1.1
    this.leg3.position.z = -2.5
    this.leg3.rotation.y = Math.PI / 2

    this.tentacles.add(this.leg3)

    this.geometry = new TubeGeometry(path, 20, 2, 2, false)
    this.leg5Material = new MeshToonMaterial({ color: 0xdd98dc })
    this.materials.push(this.leg5Material)
    this.leg5 = new Mesh(this.geometry, this.leg5Material)
    this.leg5.scale.set(0.1, 0.1, 0.1)
    this.leg5.position.x = 1
    this.leg5.position.y = -1.1
    this.leg5.position.z = -3.5
    this.leg5.rotation.y = Math.PI / 2

    this.tentacles.add(this.leg5)

    this.geometry = new TubeGeometry(path, 20, 2, 3, false)
    this.leg4Material = new MeshToonMaterial({ color: 0xd656d2 })
    this.materials.push(this.leg4Material)
    this.leg4 = new Mesh(this.geometry, this.leg4Material)
    this.leg4.scale.set(0.1, 0.1, 0.1)
    this.leg4.position.x = 1
    this.leg4.position.y = -1
    this.leg4.position.z = -3
    this.leg4.rotation.y = Math.PI / 2
    this.tentacles.add(this.leg4)

    const path2 = new SecondCurve(8)
    this.geometry = new TubeGeometry(path2, 16, 2, 3, false)
    this.leg2Material = new MeshToonMaterial({ color: 0xd656d2 })
    this.materials.push(this.leg2Material)
    this.leg2 = new Mesh(this.geometry, this.leg2Material)
    this.leg2.scale.set(0.1, 0.1, 0.1)
    this.leg2.position.x = 0.6
    this.leg2.position.y = -1.5
    this.leg2.position.z = -3
    this.leg2.rotation.y = Math.PI / 2
    this.tentacles.add(this.leg2)
  }
}

export default JellyFish
